'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardImage = require('../ContentCardImage');

var _ContentCardImage2 = _interopRequireDefault(_ContentCardImage);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _TheScoreContentCardSource = require('../TheScoreContentCardSource');

var _TheScoreContentCardSource2 = _interopRequireDefault(_TheScoreContentCardSource);

var _TheScoreSmallArticleContentCardItem = require('./TheScoreSmallArticleContentCardItem.css');

var _TheScoreSmallArticleContentCardItem2 = _interopRequireDefault(_TheScoreSmallArticleContentCardItem);

var _ContentCardFooter = require('../ContentCardFooter');

var _ContentCardFooter2 = _interopRequireDefault(_ContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheScoreSmallArticleContentCardItem = function (_React$PureComponent) {
  _inherits(TheScoreSmallArticleContentCardItem, _React$PureComponent);

  function TheScoreSmallArticleContentCardItem() {
    _classCallCheck(this, TheScoreSmallArticleContentCardItem);

    return _possibleConstructorReturn(this, (TheScoreSmallArticleContentCardItem.__proto__ || Object.getPrototypeOf(TheScoreSmallArticleContentCardItem)).apply(this, arguments));
  }

  _createClass(TheScoreSmallArticleContentCardItem, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash + ' ' + 'smallContainer'
        },
        this.props.imageURL && _react2.default.createElement(
          'a',
          { href: this.props.uri, title: this.props.text, className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash
          },
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash + ' ' + 'imageWrapper'
            },
            _react2.default.createElement(_ContentCardImage2.default, {
              alt: this.props.imageAltText,
              src: this.props.imageURL,
              hideGradient: true,
              styleOverrides: { contentCardImageStyles: { width: 'auto', maxHeight: '100px' } }
            })
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash + ' ' + 'contentWrapper'
          },
          this.props.leagueSlug && _react2.default.createElement(
            'a',
            { href: this.props.leagueSlug && '/' + this.props.leagueSlug + '/news', className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash
            },
            _react2.default.createElement(
              'div',
              {
                className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash + ' ' + 'articleTag'
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash + ' ' + 'tagText'
                },
                this.props.leagueSlug
              )
            )
          ),
          _react2.default.createElement(
            'a',
            { href: this.props.uri, className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash
            },
            _react2.default.createElement(_ContentCardText2.default, {
              text: this.props.text,
              isImageCard: false,
              styleOverrides: { contentCardTextStyles: { marginBottom: '5px' } }
            })
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-' + _TheScoreSmallArticleContentCardItem2.default.__scopedHash + ' ' + 'footerWraper'
            },
            _react2.default.createElement(_ContentCardFooter2.default, {
              publishedAt: this.props.publishedAt,
              source: _react2.default.createElement(_TheScoreContentCardSource2.default, {
                styleOverrides: this.props.styleOverrides ? this.props.styleOverrides.theScoreContentCardSourceStyles : null
              })
            })
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _TheScoreSmallArticleContentCardItem2.default.__scopedHash,
          css: _TheScoreSmallArticleContentCardItem2.default.__scoped
        })
      );
    }
  }]);

  return TheScoreSmallArticleContentCardItem;
}(_react2.default.PureComponent);

TheScoreSmallArticleContentCardItem.propTypes = {
  imageAltText: _propTypes2.default.string,
  imageURL: _propTypes2.default.string,
  text: _propTypes2.default.string.isRequired,
  publishedAt: _propTypes2.default.string.isRequired,
  leagueSlug: _propTypes2.default.string,
  uri: _propTypes2.default.string,
  styleOverrides: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

TheScoreSmallArticleContentCardItem.defaultProps = {
  imageAltText: '',
  imageURL: null,
  styleOverrides: null,
  leagueSlug: null,
  uri: '/'
};

exports.default = TheScoreSmallArticleContentCardItem;